import PropTypes from 'prop-types';
import React from 'react';

const InputSelect = ({
  name,
  label,
  value,
  options,
  error,
  onChange,
  isDisabled,
}) => (
  <div className={'ccfp__content__form__input-select'}>
    <div
      className={`ccfp__content__form__input-select__label ${
        error ? 'ccfp__content__form__input-select__label--has-error' : ''
      }`}
    >
      <label htmlFor={name}>{label}</label>
    </div>

    <div
      className={`ccfp__content__form__input-select__select ${
        error ? 'ccfp__content__form__input-select__select--has-error' : ''
      }`}
    >
      <select
        onChange={e => onChange(e)}
        name={name}
        id={name}
        value={value}
        disabled={isDisabled}
      >
        <option value={''} disabled selected>
          {label}
        </option>
        {options.map((option, index) => (
          <option value={option.value} key={index}>
            {option.text}
          </option>
        ))}
      </select>
      <p className={'error-text'}>{error}</p>
    </div>
  </div>
);

InputSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.string,
    }),
  ).isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default InputSelect;
